<template>
  <div class="flex min-h-9 gap-4 sm:min-h-12">
    <AppImage
      v-for="(pictogram, index) in environmentPictograms"
      :key="index"
      class="size-9 object-contain sm:size-12"
      :src="pictogram"
      :alt="$t('alt.pictograms_environment')"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
})

const environmentPictograms = computed(() => {
  const { customFields } = props.data

  if (!customFields) {
    return []
  }
  // Return an array of values where the key starts with the specified prefix
  return Object.keys(customFields)
    .filter(key => /^PIM_PRODUCT_ATTACHMENT_CUSTOM_FIELD_piktogrammeumweltzertifizierung_\d+_URL$/.test(key))
    .map(key => customFields[key])
})
</script>
